(() => {
  'use strict';
  function mount() {
    document.querySelectorAll('[data-jf-filters]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const trigger = root.querySelector('[data-jf-open]');
      const panel = root.querySelector('[data-jf-panel]');
      const backdrop = root.querySelector('.jf-filters__backdrop');
      let previousOverflow = '';
      function close() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
        panel?.removeAttribute('role');
        panel?.removeAttribute('aria-modal');
        if (backdrop) backdrop.hidden = true;
        document.body.style.overflow = previousOverflow;
        if (trigger?.getClientRects().length) trigger.focus({preventScroll:true});
        else panel?.querySelector('summary')?.focus({preventScroll:true});
      }
      trigger?.addEventListener('click', () => {
        if (root.classList.contains('is-open')) return;
        previousOverflow = document.body.style.overflow;
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-label', trigger.textContent.trim());
        panel.setAttribute('aria-modal', 'true');
        backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
        panel.querySelector('[data-jf-close]')?.focus();
      });
      root.querySelectorAll('[data-jf-close]').forEach(button => button.addEventListener('click', close));
      root.addEventListener('keydown', event => {
        if (!root.classList.contains('is-open')) {
          if (event.key === 'Escape') {
            const details = event.target.closest('.jf-filter[open]');
            if (details) { event.preventDefault(); details.open = false; details.querySelector('summary')?.focus(); }
          }
          return;
        }
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const items = Array.from(panel.querySelectorAll('a[href],button,input,select,summary')).filter(el => !el.disabled && el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      root.querySelector('[data-jf-sort] select')?.addEventListener('change', event => event.target.form.requestSubmit());
      root.querySelectorAll('form').forEach(form => form.addEventListener('formdata', event => {
        form.querySelectorAll('input[type=number]').forEach(input => { if (input.value === '') event.formData.delete(input.name); });
      }));
      document.addEventListener('click', event => {
        if (window.matchMedia('(max-width:749px)').matches) return;
        root.querySelectorAll('.jf-filter[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
      });
      window.matchMedia('(min-width:750px)').addEventListener('change', event => { if (event.matches) close(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
